module.exports = __webpack_public_path__ + "img/SALE.831fb7ca.svg";